import { render, staticRenderFns } from "./CadSalaoSpa.vue?vue&type=template&id=4698d787&"
import script from "./CadSalaoSpa.vue?vue&type=script&lang=js&"
export * from "./CadSalaoSpa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports